import { render, staticRenderFns } from "./BtnExit.vue?vue&type=template&id=4e41f5c4&"
import script from "./BtnExit.vue?vue&type=script&lang=js&"
export * from "./BtnExit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports